import AccountInfoClientTab from 'admin/features/clients/viewClientDetails/accountInfoClientTab';
import EditAccountInfo from 'app/features/profile/accountInfo/editAccountInfo';
import ChangePassword from 'app/features/profile/changePassword';
import EditPersonalDetails from 'app/features/profile/personalDetails/editPersonalDetails';
import ViewPersonalDetails from 'app/features/profile/personalDetails/viewPersonalDetails';
import ViewProfile from 'app/features/profile/viewProfile';
import { UserRoleEnum } from 'app/services/user';
import { Navigate, Route } from 'react-router-dom';
import { ProtectedRoleRoute } from 'utils/RequireAuth';
import BusinessesRoutes from './BusinessesRoutes';

export default function ClientProfileRotues() {
  return (
    <>
      <Route path="profile" element={<ViewProfile />}>
        <Route path="" element={<Navigate replace to="account" />} />
        <Route path="account">
          <Route path="" element={<AccountInfoClientTab />} />
          <Route path="edit" element={<EditAccountInfo />} />
          <Route element={<ProtectedRoleRoute roles={[UserRoleEnum.CLIENT]} />}>
            <Route path="changePassword" element={<ChangePassword />} />
          </Route>
        </Route>

        <Route path="personalDetails">
          <Route path="" element={<ViewPersonalDetails />} />
          <Route path="edit" element={<EditPersonalDetails />} />
        </Route>

        {BusinessesRoutes()}
      </Route>
    </>
  );
}
